import { z } from 'zod';

export const resetPasswordSchema = z.object({
  email: z.string({ required_error: 'El. paštas privalomas!' }).email('El. pašto formatas netinkamas!'),
});

export type resetPasswordSchemaInputs = z.infer<typeof resetPasswordSchema>;
